import { Component } from "react";
import Fab from "@mui/material/Fab";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Icon from "@mui/material/Icon/Icon";
import FooterFixedOnScreen from "../Layout/FooterFixedOnScreen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignInAlt, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import {
    clearLiquidBottle,
    liquidBottleTakeFetch,
    liquidBottleReleaseFetch,
} from "../../redux/liquidBottles/liquidBottlesActions";
import { connect } from "react-redux";
import CustomizedTextField from "../../components/Input/CustomizedTextField";

const styles = (theme) => ({
    card: {
        minWidth: 100,
        marginBottom: "85px",
    },
    textField: {
        width: "100%",
        margin: theme.spacing(1),
    },
    textField_50: {
        width: "45%",
        margin: theme.spacing(1),
    },
    table: {
        tableLayout: "auto",
        width: "100%",
    },
    tableCell: {
        padding: "8px 8px 8px 8px",
    },
});

class LiquidBottleFound extends Component {
    takeBottle() {
        if (this.props.liquidBottle)
            this.props.liquidBottleTakeFetch(
                this.props.activeUser.id,
                this.props.activeUser.emp_id,
                this.props.liquidBottle.code
            );
    }

    releaseBottle() {
        if (this.props.liquidBottle)
            this.props.liquidBottleReleaseFetch(
                this.props.activeUser.id,
                this.props.activeUser.emp_id,
                this.props.liquidBottle.code
            );
    }

    handleClearLiquidBottle() {
        this.props.clearLiquidBottle();
    }

    render() {
        const { classes } = this.props;

        if (!this.props.liquidBottle) return <div></div>;

        return (
            <div className="offset-lg-3 col-lg-6 col-md-12 col-sm-12 col-12 without-side-padding">
                <Card className={classes.card}>
                    <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                        <CustomizedTextField
                            className={classes.textField_50}
                            disabled
                            value={this.props.liquidBottle.code}
                            label="N° bouteille"
                            inputProps={{
                                style: { fontWeight: "bold", color: "Black" },
                            }}
                        />
                        <CustomizedTextField
                            className={classes.textField_50}
                            disabled
                            value={this.props.liquidBottle.product_code}
                            label="Code article"
                        />
                        <div>
                            <CustomizedTextField
                                className={classes.textField_50}
                                disabled
                                value={
                                    this.props.liquidBottle.stock_available + " " + this.props.liquidBottle.product_uom
                                }
                                label="Qté disponible"
                            />
                            <CustomizedTextField
                                className={classes.textField_50}
                                disabled
                                value={
                                    this.props.liquidBottle.temp_available_qty +
                                    " " +
                                    this.props.liquidBottle.product_uom
                                }
                                label="Qté disponible temp."
                            />
                        </div>
                        <div>
                            <CustomizedTextField
                                className={classes.textField}
                                disabled
                                value={this.props.liquidBottle.assigned_to}
                                label="Assigné à"
                            />
                            <CustomizedTextField
                                className={classes.textField}
                                disabled
                                value={this.props.liquidBottle.last_customer}
                                label="Dernier client"
                            />
                            <CustomizedTextField
                                className={classes.textField}
                                disabled
                                value={this.props.liquidBottle.extraction_date}
                                label="Date extraction"
                                inputProps={{ style: { color: "orange" } }}
                            />
                            <br />
                            <Typography variant="h5" component="h2">
                                Mouvements
                                <Divider light />
                            </Typography>
                            <div>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableCell}>Date</TableCell>
                                            <TableCell className={classes.tableCell}>Qté</TableCell>
                                            <TableCell className={classes.tableCell}>Unité</TableCell>
                                            <TableCell className={classes.tableCell}>Type</TableCell>
                                            <TableCell className={classes.tableCell}>Partenaire</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.props.liquidBottle.move_ids &&
                                            this.props.liquidBottle.move_ids.map((x, i) => {
                                                return (
                                                    <TableRow key={i}>
                                                        <TableCell
                                                            component="th"
                                                            scope="row"
                                                            className={classes.tableCell}
                                                        >
                                                            {x.date}
                                                        </TableCell>
                                                        <TableCell align="right" className={classes.tableCell}>
                                                            {x.quantity}
                                                        </TableCell>
                                                        <TableCell className={classes.tableCell}>{x.uom}</TableCell>
                                                        <TableCell className={classes.tableCell}>
                                                            {x.type}
                                                            <br />
                                                            {x.state === "done" && "validé"}
                                                        </TableCell>
                                                        <TableCell className={classes.tableCell}>
                                                            {x.partner}
                                                            <br />
                                                            {x.affaire}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </div>
                        </div>
                    </CardContent>
                </Card>
                <FooterFixedOnScreen>
                    <div className="row">
                        <div className="col-lg-2 col-md-2 col-sm-4 col-4">
                            <Fab
                                onClick={this.handleClearLiquidBottle.bind(this)}
                                color="primary"
                                className="div-center"
                            >
                                <Icon>arrow_back</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">Autre scan</span>
                        </div>
                        <div className="offset-lg-3 col-lg-2 offset-md-3 col-md-2 col-sm-4 col-4">
                            <div className="center">
                                <Fab onClick={this.takeBottle.bind(this)} className="green-button div-center">
                                    <FontAwesomeIcon icon={faSignOutAlt} />
                                </Fab>
                                <span className="floating-btn-text span-center">Prendre</span>
                            </div>
                        </div>
                        <div className="offset-lg-3 col-lg-2 offset-md-3 col-md-2 col-sm-4 col-4">
                            <div className="center">
                                <Fab onClick={this.releaseBottle.bind(this)} className="red-button div-center">
                                    <FontAwesomeIcon icon={faSignInAlt} />
                                </Fab>
                                <span className="floating-btn-text span-center">Déposer</span>
                            </div>
                        </div>
                    </div>
                </FooterFixedOnScreen>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        liquidBottle: state.liquidBottle,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearLiquidBottle: () => dispatch(clearLiquidBottle()),
        liquidBottleTakeFetch: (userId, empId, code) => dispatch(liquidBottleTakeFetch(userId, empId, code)),
        liquidBottleReleaseFetch: (userId, empId, code) => dispatch(liquidBottleReleaseFetch(userId, empId, code)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(LiquidBottleFound);
